import { Badge } from "../ui/badge"
import { cn } from "../../lib/utils"

type Status = "new" | "assigned" | "in-progress" | "resolved" | "closed" | "paused"

interface StatusBadgeProps {
  status: Status | string
  className?: string
}

const statusConfig: Record<Status, { label: string; className: string }> = {
  new: { 
    label: "Новая", 
    className: "bg-status-new/10 text-status-new border-status-new/20" 
  },
  assigned: { 
    label: "Назначена", 
    className: "bg-status-assigned/10 text-status-assigned border-status-assigned/20" 
  },
  "in-progress": { 
    label: "В работе", 
    className: "bg-status-assigned/10 text-status-assigned border-status-assigned/20" 
  },
  resolved: { 
    label: "Решена", 
    className: "bg-status-resolved/10 text-status-resolved border-status-resolved/20" 
  },
  closed: { 
    label: "Закрыта", 
    className: "bg-status-closed/10 text-status-closed border-status-closed/20" 
  },
  paused: { 
    label: "Пауза", 
    className: "bg-status-paused/10 text-status-paused border-status-paused/20" 
  },
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status as Status] || { label: status, className: "bg-muted text-muted-foreground border-border" }
  return (
    <Badge 
      variant="outline" 
      className={cn("text-xs font-medium border", config.className, className)}
    >
      {config.label}
    </Badge>
  )
}

